import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Agendamento } from "../../../../services/Agendamento";
import { IGetAgendamentosProps } from "../../../../types/agendamento";

export const useAgendamentosLista = (props: IGetAgendamentosProps) => {
  const query = useQuery({
    queryKey: ["agendamentos-lista", props],
    queryFn: () => Agendamento.get(props),
    select: (response) => response.data,
  });

  useEffect(() => {
    if (!query.isError) return;

    const {
      response: {
        data: { mensagem },
      },
    } = query.error as any;

    toast.error(mensagem);
  }, [query.isError]);

  return query;
};
